<template>
  <v-dialog
    :value="true"
    width="800"
    persistent
  >
    <v-card>
      <div
        style="background: rgba(0,0,0,0.04);padding: 10px;vertical-align:middle;"
      >
        <v-btn
          fab
          color="primary"
          dark
          style="vertical-align:middle;"
        >
          <v-icon
            size="48"
            style="padding-right:3px;"
          >
            mdi-history
          </v-icon>
        </v-btn>
        <span
          style="font-size: 24px;font-weight: 600;padding: 10px;vertical-align:middle;"
        >
          Activity Log&nbsp;&nbsp;
          <small><u>{{logs.length}}</u> events</small>
        </span>
        <v-btn
          fab
          color="red"
          dark
          flat
          style="vertical-align:middle;display:inline-block;float:right;font-size: 18px"
          @click="$emit('close')"
        >
          X
        </v-btn>
      </div>
      <v-data-table
        hide-actions
        :items="logs"
        :headers="headers"
        :total-items="logs.length"
        :loading="loading"
        disable-initial-sort
      >
        <template
          slot="items"
          slot-scope="props"
        >
          <td>
            {{props.item.text}}
          </td>
          <td>
            {{props.item.full_name}}
          </td>
          <td>
            {{convertToLocal(props.item.date)}}
          </td>
        </template>
      </v-data-table>
      <v-card-actions>
        <v-spacer />
        <v-btn
          flat
          color="primary"
          @click="$emit('close')"
        >
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from '@/api'

export default {
  name: 'UserFormLog',
  props: [ 'userform' ],
  data () {
    return {
      logs: JSON.parse(JSON.stringify(this.userform.logs)),
      loading: false,
      headers: [
        { text: 'Action', value: 'text', sortable: false, width: 400 },
        { text: 'User', value: 'full_name', sortable: false },
        { text: 'Date', value: 'date', sortable: false },
      ],
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    fetch () {
      this.signatures = null
      this.loading = true
      api.userform.userForm.getActivity(this.userform.id)
        .then(results => {
          this.logs = results
          this.loading = false
        })
    }
  }
}
</script>
